<template>
	<div class="cart">
		<HeadingSVG imgName="buy-insurance" altText="Buy Insurance" />
		<div class="plan-types-wrapper">
			<div class="plan-type" v-for="type in types" :key="type.id">
				<div class="policy-name">{{ type.name }} Policy:
					<span v-if="purchasedPlan(type)">
						{{ purchasedPlan(type).title }}
					</span>
				</div>
				<div class="premium">{{ ui.premium_label }}
					<AnimatedNumber
						v-if="purchasedPlan(type)"
						:number="premium(type)"
						:filters="'currency'"
					/>
				</div>
				<FlipButton :action="shop(type)">{{ label(type) }} {{ type.title }}</FlipButton>
			</div>
		</div>
		<MarqueeButton class="filled" :action="advance" :disabled="!canAdvance">
			{{ ui.buy_button }}
		</MarqueeButton>
	</div>
</template>

<script>
import AnimatedNumber from '@/components/base/AnimatedNumber';
import FlipButton from '@/components/base/FlipButton';
import HeadingSVG from '@/components/base/HeadingSVG';
import MarqueeButton from '@/components/base/MarqueeButton';
import { mapGetters, mapState } from "vuex";

export default {
	name: 'Shop',
	components: {
		AnimatedNumber,
		FlipButton,
		HeadingSVG,
		MarqueeButton,
	},
	computed: {
		...mapGetters({
			ids: "game/insurance/available",
		}),
		...mapState({
			ui: (state) => state.global.api.data.ui.combo_round,
		}),
		types() {
			return this.ids.reduce(
				(types, id) => [...types, this.$store.state.game.insurance[id]], []
			);
		},
		canAdvance() {
			return this.$store.getters["game/plans/owned"].length === this.types.length;
		},
	},
	methods: {
		label(type) {
			return this.$store.state.game.plans[type.id] ? "Change" : "Select";
		},
		purchasedPlan(type) {
			return this.$store.state.game.plans[type.id];
		},
		premium(type) {
			return this.$store.getters[`game/plans/${type.id}/totalCost`];
		},
		shop(type) {
			return () => {
				this.$router.push(`/game/shop/plans/${type.id}`);
				this.$store.dispatch("sound/fx/play", { id: "button_generic" });
			};
		},
		advance() {
			this.$router.push('/game/shop/complete');
			this.$store.dispatch("sound/fx/play", { id: "button_generic" });
		},
	},
};
</script>

<style lang="scss" scoped>
	.cart {
		width: 100%;
		margin-bottom: 40px;

		@include tablet { min-height: unset; }
		@include desktop { margin-bottom: 0; }
	}

	.plan-types-wrapper {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
		width: 100%;

		@include tablet {
			flex-grow: 1;
			flex-direction: row;
			justify-content: space-around;
			padding: 0 20px;
			margin-bottom: 20px;
		}

		@include desktop {
			justify-content: space-between;
			padding: 0;
		}
	}

	.plan-type {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: center;
		margin-bottom: 40px;

		@include tablet {
			flex: 1 1 0px;
			margin: 40px 0;
		}

		@include desktop { justify-content: space-between; }
	}

	.policy-name {
		font-family: $heading-font;
		font-size: $font-size-md;
		letter-spacing: $letter-spacing-plus;
		color: $alt-color-extra-light;
		text-transform: uppercase;
		white-space: nowrap;

		@include tablet { font-size: $font-size-lg; }

		span { margin-left: .5ex; }
	}

	.policy-name,
	.premium {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.two-tone-plan-selector {
		@include mobile { margin: .5em 0 0; }
	}

	.marquee-btn {
		@include desktop { margin-bottom: 100px; }
	}

	.animated-number {
		color: $primary-color-extra-light;
		font-size: $font-size-lg;
		margin-left: .5ex;

		@include desktop { font-size: $font-size-xl; }
	}
</style>
